var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106.495,
    height: 22.281,
    viewBox: "0 0 106.495 22.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "q8aifmw6ja"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 462",
    style: {
      fill: "none"
    },
    d: "M0 0h106.495v22.281H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0try9uq9tb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 452",
    style: {
      fill: "none"
    },
    d: "M0 0h1.407v1.537H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f8v8ns17xc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 453",
    style: {
      fill: "none"
    },
    d: "M0 0h1.499v1.656H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ta3lybm8ad"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 454",
    style: {
      fill: "none"
    },
    d: "M0 0h1.3v1.336H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "of2ve1btse"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 455",
    style: {
      fill: "none"
    },
    d: "M0 0h1.318v1.318H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ql69h8hy1f"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 456",
    style: {
      fill: "none"
    },
    d: "M0 0h.932v1.185H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6faj4ug92g"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 457",
    style: {
      fill: "none"
    },
    d: "M0 0h1.226v1.226H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zeb2kpe0uh"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 458",
    style: {
      fill: "none"
    },
    d: "M0 0h1.066v1.066H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b23bf6sr8i"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 459",
    style: {
      fill: "none"
    },
    d: "M0 0h1.104v1.233H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 767",
    style: {
      clipPath: "url(#q8aifmw6ja)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 766"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 765",
    style: {
      clipPath: "url(#q8aifmw6ja)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 99",
    d: "m397.9 134.941-.066-.046a12.702 12.702 0 0 0-.685-.39 3.415 3.415 0 0 0-.872-.3 1.88 1.88 0 0 0-.522-.142 10.183 10.183 0 0 1-.369-.051 4.63 4.63 0 0 0-.449-.037c-.1 0-.214-.011-.357-.027a6.81 6.81 0 0 0-.571-.021h-.5c-.166 0-.339 0-.524.012a4.778 4.778 0 0 1-.495-.006 9.343 9.343 0 0 0-1.444.09c-.538.069-1.027.136-1.461.2a2.57 2.57 0 0 0-.9.211 1.65 1.65 0 0 0-.512.363 1.242 1.242 0 0 0-.247.332 1.91 1.91 0 0 0-.128.321 1.834 1.834 0 0 0-.07.388.429.429 0 0 1-.014.082l-.048.407a2.367 2.367 0 0 0 0 .4l1.021 11.675a2.769 2.769 0 0 0 .176.8 4.491 4.491 0 0 0 .228.489 1.531 1.531 0 0 0 .692.695 2.081 2.081 0 0 0 .761.18 3.274 3.274 0 0 0 .507-.008 4.32 4.32 0 0 0 .262-.031 2.082 2.082 0 0 0 .86-.32 1.705 1.705 0 0 0 .734-1.187q.061-.454.091-.882l-.323-3.8c.218-.03.412-.056.586-.077.213-.027.475-.068.777-.124a20.39 20.39 0 0 0 1.856-.405 8.487 8.487 0 0 0 1.752-.7 3.977 3.977 0 0 0 1.806-1.68 4.585 4.585 0 0 0 .538-2.177 5.455 5.455 0 0 0-.542-2.315 5.244 5.244 0 0 0-1.543-1.92m-2.294 4.668a1.93 1.93 0 0 1-.654.46 4.482 4.482 0 0 1-.981.305 10.269 10.269 0 0 1-1.049.152l-.582.06v-.014c-.021-.24-.036-.481-.046-.762l-.114-1.3q-.022-.255-.05-.519l.174-.008.952-.04c.137-.005.249-.012.336-.018a5.806 5.806 0 0 1 .876.108 2.861 2.861 0 0 1 .753.255 1.137 1.137 0 0 1 .421.356.883.883 0 0 1 .146.466.724.724 0 0 1-.182.5",
    transform: "translate(-374.227 -129.286)",
    style: {
      fillRule: "evenodd",
      fill: "#28ac4c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 740",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 739"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 738",
    style: {
      clipPath: "url(#0try9uq9tb)"
    },
    transform: "translate(14.581 5.836)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 100",
    d: "M421.192 169.986c.219.184.656.022.977-.361s.4-.842.185-1.025-.656-.022-.977.361-.4.842-.185 1.025",
    transform: "translate(-421.07 -168.524)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 101",
    d: "M2365.624 148.12a11.772 11.772 0 0 0 .011-1.534v-.011a8.767 8.767 0 0 0-.575-2.482 8.075 8.075 0 0 0-1.346-2.291 7.3 7.3 0 0 0-2.087-1.7 6.178 6.178 0 0 0-2.821-.734l-3.532-.085-.191.009-.09.041a1.245 1.245 0 0 0-.574.065l-.24.1a1.578 1.578 0 0 0-.4.237 1.309 1.309 0 0 0-.471.652 2.487 2.487 0 0 0-.172.62 1.52 1.52 0 0 0-.058.413v12.377a2.379 2.379 0 0 0 .015.258c.009.083.022.17.041.262l.024.09c.025.072.045.141.062.2a1.566 1.566 0 0 0 .142.351 2.227 2.227 0 0 0 .135.261 1.182 1.182 0 0 0 .357.38 1.76 1.76 0 0 0 .838.354 5.54 5.54 0 0 0 1.105.135h.21c.283 0 .564-.012.82-.035a18.692 18.692 0 0 0 3.014-.385 7.329 7.329 0 0 0 2.876-1.278 6.107 6.107 0 0 0 1.889-2.208 9.329 9.329 0 0 0 .849-2.565c.073-.482.129-.986.165-1.5m-4.74.912a3.969 3.969 0 0 1-.5 1.235 2.956 2.956 0 0 1-.7.775 3.137 3.137 0 0 1-.843.44 4.242 4.242 0 0 1-1 .208q-.236.021-.481.036v-4.971c0-.474.007-.961.021-1.484v-1.655c.151.009.3.022.456.037a6.43 6.43 0 0 1 1.094.2 3.151 3.151 0 0 1 .844.37 1.731 1.731 0 0 1 .532.527 4.808 4.808 0 0 1 .513 1.264 6.738 6.738 0 0 1 .21 1.512 6.078 6.078 0 0 1-.151 1.506",
    transform: "translate(-2271.596 -134.457)",
    style: {
      fill: "#f84c4e",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 102",
    d: "M1171.39 179.021a10.213 10.213 0 0 0-.394-1.85 8.58 8.58 0 0 0-1-2.21 5.8 5.8 0 0 0-1.672-1.71 5.389 5.389 0 0 0-2.34-.843 7.257 7.257 0 0 0-2.909.31h-.005a5.144 5.144 0 0 0-1.9 1.044 7.675 7.675 0 0 0-1.37 1.562 8.261 8.261 0 0 0-.91 1.827 9.972 9.972 0 0 0-.459 1.788 13.206 13.206 0 0 0-.132 1.885 11.265 11.265 0 0 0 .18 2.005 9.288 9.288 0 0 0 .58 1.959 6.22 6.22 0 0 0 1.1 1.743 5.829 5.829 0 0 0 1.275 1.1 6.727 6.727 0 0 0 1.472.7 6.867 6.867 0 0 0 1.577.325l.094.007a6.457 6.457 0 0 0 3.639-.842 5.284 5.284 0 0 0 1.707-1.607 8.007 8.007 0 0 0 .505-.855 6.959 6.959 0 0 0 .393-.945 9.928 9.928 0 0 0 .451-1.669 12.475 12.475 0 0 0 .113-3.726m-4.456 3.589-.008.027a3.319 3.319 0 0 1-.393.881 1.888 1.888 0 0 1-1.382 1.068 1.91 1.91 0 0 1-1.061-.131 2.176 2.176 0 0 1-.919-.733 2.656 2.656 0 0 1-.4-.795 5.788 5.788 0 0 1-.222-1.041 7.1 7.1 0 0 1-.049-1.106 10.035 10.035 0 0 1 .1-1.1 6.008 6.008 0 0 1 .539-1.859 2.685 2.685 0 0 1 .471-.694 1.668 1.668 0 0 1 .586-.406 2.635 2.635 0 0 1 1.131-.232 1.477 1.477 0 0 1 .744.233 1.807 1.807 0 0 1 .552.616 4.419 4.419 0 0 1 .426 1.057 7.8 7.8 0 0 1 .218 2.182 7.3 7.3 0 0 1-.334 2.033",
    transform: "translate(-1118.191 -166.399)",
    style: {
      fill: "#4d9de0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 103",
    d: "M12.589 145.654a4.158 4.158 0 0 0-1.263-1.685 5.532 5.532 0 0 0-1.889-.962 6.725 6.725 0 0 0-2.1-.293c-.614.012-1.236 0-1.852-.026a4.268 4.268 0 0 1-.55-.062 1.768 1.768 0 0 1-.427-.131.726.726 0 0 1-.241-.175.343.343 0 0 1-.071-.2 1 1 0 0 1 .018-.5 1.029 1.029 0 0 1 .226-.395 1.4 1.4 0 0 1 .431-.306 3.28 3.28 0 0 1 .679-.233 4.819 4.819 0 0 1 1.371-.062 2.565 2.565 0 0 1 1.119.332c.146.1.307.21.483.335a4.472 4.472 0 0 0 .66.386 2.122 2.122 0 0 0 .88.209 1.679 1.679 0 0 0 1.064-.383 1.588 1.588 0 0 0 .673-1.183 2.252 2.252 0 0 0-.23-1.1 3.57 3.57 0 0 0-.605-.885 3.854 3.854 0 0 0-.705-.613 4.551 4.551 0 0 0-1.11-.564 7.171 7.171 0 0 0-1.266-.316 9.412 9.412 0 0 0-1.353-.113 10.6 10.6 0 0 0-1.365.074 9.46 9.46 0 0 0-2.2.529 4.66 4.66 0 0 0-1.809 1.222 4.766 4.766 0 0 0-1.007 2.017 5.306 5.306 0 0 0-.061 2.222 4.938 4.938 0 0 0 .88 2.026 3.725 3.725 0 0 0 1.916 1.356 5.729 5.729 0 0 0 1.152.265c.356.043.726.072 1.1.085s.719.017 1.07.015a7.505 7.505 0 0 1 .92.052 5.075 5.075 0 0 1 .727.161 1.6 1.6 0 0 1 .458.216.833.833 0 0 1 .244.279 1.36 1.36 0 0 1 .132.536 1.059 1.059 0 0 1-.155.679 1.767 1.767 0 0 1-.622.6 2.736 2.736 0 0 1-.994.34 2.9 2.9 0 0 1-1.1-.047 3.511 3.511 0 0 1-.758-.421 2.054 2.054 0 0 1-.526-.53 1.821 1.821 0 0 0-.615-.66 2.134 2.134 0 0 0-.718-.289 2.778 2.778 0 0 0-1.355.079 1.676 1.676 0 0 0-.841.614 2.119 2.119 0 0 0-.346.808 2.292 2.292 0 0 0 0 .881 2.12 2.12 0 0 0 .3.766A6.438 6.438 0 0 0 2 151.908a5.167 5.167 0 0 0 1.435.97 6.63 6.63 0 0 0 2.792.548q.337 0 .669-.033a8.3 8.3 0 0 0 2.205-.5 7.232 7.232 0 0 0 2.426-1.5 4.526 4.526 0 0 0 1.374-2.479 5.136 5.136 0 0 0 .094-.77 6.184 6.184 0 0 0-.15-1.71 4.244 4.244 0 0 0-.256-.778",
    transform: "translate(.001 -131.997)",
    style: {
      fill: "#f84c4e",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 743",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 742"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 741",
    style: {
      clipPath: "url(#f8v8ns17xc)"
    },
    transform: "translate(1.112 6.718)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 104",
    d: "M32.235 195.576c.219.184.681-.007 1.032-.426s.459-.907.24-1.09-.681.007-1.032.426-.459.907-.24 1.09",
    transform: "translate(-32.122 -193.99)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 105",
    d: "M2196.027 129.024c-.019-.111-.04-.217-.068-.321s-.053-.19-.085-.291l-.029-.077a1.616 1.616 0 0 0-.378-.567 1.554 1.554 0 0 0-.878-.473 4.044 4.044 0 0 0-.331-.041 2.53 2.53 0 0 0-1.338.242l-.1.06a2.165 2.165 0 0 0-.677.814 3.142 3.142 0 0 0-.3 1.178c0 .15 0 .3-.01.435s-.017.281-.033.49a29.257 29.257 0 0 0-.042 1.475v2.95c0 .491-.008.968-.021 1.448l-.043 5.273a2.452 2.452 0 0 0 .014.556c.009.05.017.1.022.149.007.074.017.149.03.224a2.017 2.017 0 0 0 .151.723.968.968 0 0 0 .076.14.935.935 0 0 0 .109.206 1.713 1.713 0 0 0 .574.661l.1.058a2.285 2.285 0 0 0 .986.226 2.245 2.245 0 0 0 .512-.059 1.673 1.673 0 0 0 .911-.419 1.834 1.834 0 0 0 .269-.287 2.677 2.677 0 0 0 .189-.287l.063-.142c.033-.1.063-.2.085-.291a1.648 1.648 0 0 1 .051-.157l.04-.152q.026-.155.038-.271a2.354 2.354 0 0 0 .014-.246l.127-11.645v-.374c0-.065 0-.127.008-.187.009-.1.013-.214.013-.342 0-.108 0-.217-.012-.325a10.725 10.725 0 0 0-.04-.352",
    transform: "translate(-2115.789 -122.839)",
    style: {
      fill: "#ffad30",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 106",
    d: "M2716.135 158.519a2.445 2.445 0 0 0-.612-.459l-.357-.141a1.542 1.542 0 0 0-.441-.085 1.331 1.331 0 0 1-.149-.015l-.088-.009q-.58-.024-1.145 0l-2.473.086q-.5.018-.788.017h-.157q.883-1.389 1.772-2.757 1.256-1.931 2.521-3.885.274-.424.571-.849.311-.447.6-.916.142-.22.345-.55a4.372 4.372 0 0 0 .388-.8 2.665 2.665 0 0 0 .17-.913 1.406 1.406 0 0 0-.513-1.082l-.168-.107a.589.589 0 0 1-.111-.065 1.94 1.94 0 0 0-.329-.2 2.518 2.518 0 0 0-1.376-.279 7.725 7.725 0 0 1-.934.014 4.321 4.321 0 0 0-.58.007c-.159.012-.31.021-.456.026q-1.835.064-3.049.1c-.823.022-1.443.048-1.833.075l-.246.023a7.437 7.437 0 0 1-.768.076 3.157 3.157 0 0 0-1.122.26 1.955 1.955 0 0 0-.814.667 1.675 1.675 0 0 0-.3 1.034 2.5 2.5 0 0 0 .107.675 1.51 1.51 0 0 0 .514.785 1.984 1.984 0 0 0 1.012.448 6.673 6.673 0 0 0 .805.079q.829-.008 1.519-.021l1.321-.025q.641-.012 1.292-.035l-.471.765-.891 1.418c-.281.445-.566.873-.872 1.31l-1.86 2.919-1.045 1.585-.053.094a.522.522 0 0 1-.035.066.675.675 0 0 1-.061.074l-.082.106c-.036.059-.078.132-.12.215s-.073.148-.125.266a.365.365 0 0 1-.037.071 1.9 1.9 0 0 0-.132.24 1.3 1.3 0 0 0-.146.273l-.147.4a1.429 1.429 0 0 0-.067.489.8.8 0 0 0 .015.138 1.22 1.22 0 0 0 .014.246 1.419 1.419 0 0 0 .069.261 1.263 1.263 0 0 0 .547.8 2.94 2.94 0 0 0 .484.3l.21.068c.083.013.154.022.217.03l.044.006a.911.911 0 0 0 .24.041l.075.012a2.3 2.3 0 0 0 .368.017l7.927-.277a2.59 2.59 0 0 0 .283-.025 3.71 3.71 0 0 0 .218-.041 1.926 1.926 0 0 0 .648-.215 1.613 1.613 0 0 0 .627-.42 1.978 1.978 0 0 0 .24-.326 1.275 1.275 0 0 0 .171-.49 1.852 1.852 0 0 0-.333-1.52z",
    transform: "translate(-2610.068 -140.466)",
    style: {
      fill: "#36a7a7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 746",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 745"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 744",
    style: {
      clipPath: "url(#ta3lybm8ad)"
    },
    transform: "translate(94.57 6.21)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 107",
    d: "M2731.014 180.563c.209.195.615.1.907-.215s.36-.725.151-.92-.615-.1-.906.215-.36.725-.151.92",
    transform: "translate(-2730.893 -179.328)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 108",
    d: "M1825.971 145.526c-.09-.121-.188-.245-.3-.376s-.234-.27-.363-.4l-.027-.024q-.514-.6-1.05-1.191a49.475 49.475 0 0 0-1.58-1.667l-.593-.615c-.214-.221-.439-.451-.684-.7l-.156-.156 3.454-3.536.276-.276.056-.062a.8.8 0 0 1 .092-.1 2.2 2.2 0 0 0 .239-.248c.079-.081.151-.162.218-.246.052-.066.11-.138.191-.233a2.8 2.8 0 0 0 .2-.291l.167-.29a1.755 1.755 0 0 0 .145-.712l-.008-.1a1.423 1.423 0 0 0-.367-.8 1.317 1.317 0 0 0-.312-.306.937.937 0 0 1-.115-.1l-.09-.077a2.159 2.159 0 0 0-.454-.25 2.071 2.071 0 0 0-.542-.133 1.778 1.778 0 0 0-1.074.207 2.427 2.427 0 0 0-.984.652l-.318.28a7.63 7.63 0 0 0-.38.358l-.055.055q-.577.556-1.141 1.122c-.377.377-.756.765-1.162 1.188l-.075.084-.008-1.773c0-.12 0-.231-.012-.335s-.022-.2-.036-.291a2.049 2.049 0 0 0-.2-.69 1.7 1.7 0 0 0-.144-.3 1.6 1.6 0 0 0-.267-.319 1.742 1.742 0 0 0-.844-.386l-.275-.044a2.651 2.651 0 0 0-.39-.029l-.491.089a1.691 1.691 0 0 0-.554.225 1.711 1.711 0 0 0-.728.829 2.648 2.648 0 0 0-.249 1.071 5.166 5.166 0 0 0-.025.5 1.861 1.861 0 0 1-.031.329l-.011.191q-.021.754-.021 1.355c0 .4.007.86.022 1.385.042 1.026.063 2 .063 2.9l.021 5.314a1.188 1.188 0 0 0 .031.286c.011.068.02.13.026.187s.017.147.03.229a1.516 1.516 0 0 0 .168.618v.184l.151.151.007.015a1.842 1.842 0 0 0 .634.682l.068.036a2.5 2.5 0 0 0 .753.219 1.747 1.747 0 0 0 .21.013 2.122 2.122 0 0 0 .6-.092 1.641 1.641 0 0 0 .914-.435c.065-.066.128-.133.191-.2a1.275 1.275 0 0 0 .24-.416 4.16 4.16 0 0 0 .185-.613l.041-.193a1.578 1.578 0 0 0 .036-.327l-.036-2.636 2.794 2.931.275.3a1.488 1.488 0 0 1 .113.127 2.986 2.986 0 0 0 .22.247 1.924 1.924 0 0 0 .276.271l.233.191a3.315 3.315 0 0 0 .282.2c.085.054.165.1.238.147a2.111 2.111 0 0 0 .313.157 1.322 1.322 0 0 0 .451.094 1.584 1.584 0 0 0 .885-.141 1.679 1.679 0 0 0 .359-.189q.115-.081.253-.194a1.615 1.615 0 0 0 .6-.823 1.4 1.4 0 0 0-.025-1.162 2.708 2.708 0 0 0-.538-.946",
    transform: "translate(-1752.044 -127.833)",
    style: {
      fill: "#5e70d5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 109",
    d: "M777.855 144.01a2.782 2.782 0 0 1-.061-.2 3.869 3.869 0 0 0-.075-.246 1.273 1.273 0 0 0-.453-.695 1.465 1.465 0 0 0-.816-.411 2.944 2.944 0 0 0-.33-.044 4.878 4.878 0 0 0-.359-.012 2.034 2.034 0 0 0-1.035.279 2.367 2.367 0 0 0-.411.323 1.308 1.308 0 0 0-.323.534 2.779 2.779 0 0 0-.181.491 3.453 3.453 0 0 0-.094.53 11.179 11.179 0 0 0-.044.921q-.043.966-.054 1.845-.007.541-.01 1.115-.823 0-1.589-.02c-.731-.014-1.47-.021-2.253-.019l-.135.009.033-3.893a2.5 2.5 0 0 0-.025-.346 2.469 2.469 0 0 0-.159-.641 1.428 1.428 0 0 0-.407-.622 1.444 1.444 0 0 0-.875-.454 3.713 3.713 0 0 0-.667-.052 2.212 2.212 0 0 0-1 .245l-.1.059a2.269 2.269 0 0 0-.365.322 1.567 1.567 0 0 0-.3.478 2.861 2.861 0 0 0-.195.519 3.336 3.336 0 0 0-.1.533c-.016.177-.024.35-.024.519 0 .124-.006.246-.021.435-.028.549-.046 1-.053 1.406s0 .869.01 1.37v1.483c0 .473-.007.932-.021 1.389l-.043 3.116-.021 1.964a2.243 2.243 0 0 0 .014.537l.041.206a.437.437 0 0 1 .009.079l.053.371a1.946 1.946 0 0 0 .128.415l.022.045a1.258 1.258 0 0 0 .085.213l.037.064a1.992 1.992 0 0 0 .695.682 2.311 2.311 0 0 0 1.5.166 1.7 1.7 0 0 0 .885-.383 1.607 1.607 0 0 0 .523-.714c.025-.077.05-.15.077-.225a2.065 2.065 0 0 0 .085-.293 2.322 2.322 0 0 0 .085-.553l.036-4.5 4.007-.018-.036 3.629v.064l-.042.082v.352a1.13 1.13 0 0 0 .066.369c0 .031.009.062.012.094a1.347 1.347 0 0 1 .007.141l.054.371a1.759 1.759 0 0 0 .1.333l.075.208a1.325 1.325 0 0 0 .114.191 1.637 1.637 0 0 0 .616.651l.066.036a2.259 2.259 0 0 0 .984.223 2.452 2.452 0 0 0 .521-.057 1.7 1.7 0 0 0 .885-.383 1.6 1.6 0 0 0 .521-.709l.08-.23a2 2 0 0 0 .084-.29 2.327 2.327 0 0 0 .086-.556l.126-11.211v-1.123a2.726 2.726 0 0 0-.028-.376z",
    transform: "translate(-738.806 -137.47)",
    style: {
      fill: "#ff8000",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 749",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 748"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 747",
    style: {
      clipPath: "url(#of2ve1btse)"
    },
    transform: "translate(27.52 5.946)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 110",
    d: "M794.817 172.921c.2.2.611.12.914-.183s.385-.712.183-.914-.611-.12-.914.183-.385.712-.183.914",
    transform: "translate(-794.706 -171.713)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 752",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 751"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 750",
    style: {
      clipPath: "url(#ql69h8hy1f)"
    },
    transform: "translate(35.854 5.884)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 111",
    d: "M1035.511 171.058c.185.107.48-.057.659-.366s.173-.646-.013-.753-.48.057-.659.366-.173.646.013.753",
    transform: "translate(-1035.368 -169.906)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 755",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 754"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 753",
    style: {
      clipPath: "url(#6faj4ug92g)"
    },
    transform: "translate(63.619 5.734)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 112",
    d: "M1837.192 166.737c.151.151.52.029.823-.274s.426-.671.274-.822-.52-.029-.822.274-.426.671-.274.822",
    transform: "translate(-1837.127 -165.575)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 758",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 757"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 756",
    style: {
      clipPath: "url(#zeb2kpe0uh)"
    },
    transform: "translate(70.936 5.685)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 113",
    d: "M2048.486 165.15c.151.151.479.07.731-.183s.334-.58.183-.731-.479-.07-.731.183-.334.58-.183.731",
    transform: "translate(-2048.41 -164.16)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 761",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 760"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 759",
    style: {
      clipPath: "url(#b23bf6sr8i)"
    },
    transform: "translate(76.99 5.084)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 114",
    d: "M2223.466 147.994a.662.662 0 1 0-.125-.818.592.592 0 0 0 .125.818",
    transform: "translate(-2223.237 -146.818)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 764",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 763"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 762",
    style: {
      clipPath: "url(#of2ve1btse)"
    },
    transform: "translate(83.154 5.792)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 115",
    d: "M2401.361 168.456c.2.2.611.12.914-.183s.385-.712.183-.914-.611-.12-.914.183-.384.712-.183.914",
    transform: "translate(-2401.251 -167.248)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 116",
    d: "M1190.923 4.655A4.655 4.655 0 1 1 1186.269 0a4.655 4.655 0 0 1 4.655 4.655",
    transform: "translate(-1140.695)",
    style: {
      fill: "#f5f1e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 117",
    d: "M1403.519 88.776a4.655 4.655 0 1 1-4.655-4.655 4.655 4.655 0 0 1 4.655 4.655",
    transform: "translate(-1345.929 -81.208)",
    style: {
      fill: "#f5f1e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 118",
    d: "M1253.512 69.572a2.326 2.326 0 1 1-2.326-2.326 2.326 2.326 0 0 1 2.326 2.326",
    transform: "translate(-1205.613 -64.917)",
    style: {
      fill: "#6a4e3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 119",
    d: "M1466.115 153.7a2.326 2.326 0 1 1-2.326-2.326 2.326 2.326 0 0 1 2.326 2.326",
    transform: "translate(-1410.854 -146.134)",
    style: {
      fill: "#6a4e3e"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header_logo.2d48bea7fcb5325c6e22b1d8e5f72616.svg";
export { ForwardRef as ReactComponent };